import { APP_BASE_HREF, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import {
  DeviceType,
  detectDevice,
} from '@personal-area/global/browser-detection';
import { I18nService } from '@personal-area/global/i18n';

import { FBS2Links } from '../../directives/fbs2-links';
import {
  QrModalFooterComponent,
  QrPopupData,
} from '../qr-modal-footer/qr-modal-footer.component';

@Component({
  selector: 'global-footer-store-links',
  templateUrl: './footer-store-links.component.html',
  styleUrls: ['./footer-store-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgOptimizedImage],
})
export class FooterStoreLinksComponent extends FBS2Links {
  userLocationA3 = input<string>('');
  baseHref = inject(APP_BASE_HREF);
  device = detectDevice(navigator.userAgent);
  isAndroid = this.device.type === DeviceType.android;
  isIos = this.device.type === DeviceType.ios;

  isGooglePlayButtonVisible = computed(
    () => !this.excludedGooglePlayCountries.includes(this.userLocationA3()),
  );

  constructor(
    private readonly _dialog: MatDialog,
    protected _i18nService: I18nService,
  ) {
    super();
  }

  public showQr(): void {
    this._dialog.open(QrModalFooterComponent, <MatDialogConfig<QrPopupData>>{
      data: {
        location: this.userLocationA3(),
      },
      panelClass: 'regular-popup-container',
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
    });
  }
}
